import {
  MEMBER_FETCHING,
  MEMBER_FAILED,
  MEMBER_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MEMBER_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case MEMBER_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case MEMBER_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
